import './PortalIntro.css'

/**
 * The page's opening, in the learner portal.
 *
 * Type on the page field (general-style pass, 2026-10): an optional eyebrow, the
 * title, the page's actions at the far end, and the figures under it. It used to
 * be a tall band — a stock illustration under a scrim, a glow, a glass emblem
 * tile and a gold rule — opening every one of fifteen pages with the same picture
 * of a mortarboard. A learner recognises the page by its title, and the frame
 * above (the portal bar) already says where they are.
 *
 * `icon`, `art` and `image` are still accepted so no call site changes; the band
 * that drew them is gone, so they draw nothing. `heroArt.js` keeps the artwork
 * map for any screen that later wants a real photograph.
 *
 * The gap between the heading and the figures comes from `.portal__container`,
 * a flex column with its own rhythm, so a fragment is all this needs.
 *
 * @param {import('react').ReactNode} [eyebrow]  a quiet line above the title,
 *   naming what the title is an instance OF (the dashboard's greeting).
 * @param {string} title
 * @param {import('react').ReactNode} [actions]  one or two shared <Button>s.
 * @param {import('react').ReactNode} [children]  the compact stat strip, under
 *   the heading.
 */
export default function PortalIntro({ eyebrow, title, actions, children }) {
  return (
    <>
      <header className="pintro">
        <div className="pintro__heading">
          {eyebrow && (
            <p className="pintro__eyebrow">
              <bdi>{eyebrow}</bdi>
            </p>
          )}
          <h1 className="pintro__title">
            <bdi>{title}</bdi>
          </h1>
        </div>

        {actions && <div className="pintro__actions">{actions}</div>}
      </header>

      {children && <div className="pintro-figures">{children}</div>}
    </>
  )
}
